"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DlgPwdChangeSelfCtl_1 = require("../shared/dialogs/ctl/DlgPwdChangeSelfCtl");
var DlgPwdChangeAdmCtl_1 = require("../shared/dialogs/ctl/DlgPwdChangeAdmCtl");
var DlgViewTextCtl_1 = require("../shared/dialogs/ctl/DlgViewTextCtl");
var DlgOpenFileCtl_1 = require("../shared/dialogs/ctl/DlgOpenFileCtl");
var DlgLogoutCtl_1 = require("../shared/dialogs/ctl/DlgLogoutCtl");
var DlgErrorCtl_1 = require("../shared/dialogs/ctl/DlgErrorCtl");
var DlgYesNoCtl_1 = require("../shared/dialogs/ctl/DlgYesNoCtl");
var DlgSelectAvailAdminCtl_1 = require("../shared/dialogs/ctl/DlgSelectAvailAdminCtl");
var DlgSelectKeyValueItemCtl_1 = require("../shared/dialogs/ctl/DlgSelectKeyValueItemCtl");
var DlgFinanceManualOperationCtl_1 = require("./components/dialogs/ctl/DlgFinanceManualOperationCtl");
var DlgDescriptionEditCtl_1 = require("../shared/dialogs/ctl/DlgDescriptionEditCtl");
var DlgGeneratePromoCodeOperationCtl_1 = require("./components/dialogs/ctl/DlgGeneratePromoCodeOperationCtl");
var DlgApiErrorCtl_1 = require("../shared/dialogs/ctl/DlgApiErrorCtl");
var DlgMessageEditorCtl_1 = require("./components/dialogs/ctl/DlgMessageEditorCtl");
var DlgExportList_1 = require("../shared/dialogs/ctl/DlgExportList");
var DlgUploadProgessCtl_1 = require("../shared/dialogs/ctl/DlgUploadProgessCtl");
var DlgSelectBrandImage_1 = require("./components/dialogs/ctl/DlgSelectBrandImage");
var DlgSendBroadcastRawUserMessageCtl_1 = require("./components/dialogs/ctl/DlgSendBroadcastRawUserMessageCtl");
var DlgSendBroadcastRawPartnerMessageCtl_1 = require("./components/dialogs/ctl/DlgSendBroadcastRawPartnerMessageCtl");
var DlgSelectPProgramImage_1 = require("./components/dialogs/ctl/DlgSelectPProgramImage");
var DlgGenerateOnePromoCodeOperationCtl_1 = require("./components/dialogs/ctl/DlgGenerateOnePromoCodeOperationCtl");
var DlgNumericEditorCtl_1 = require("../shared/dialogs/ctl/DlgNumericEditorCtl");
var DlgSelectGameBetLinesDenomCtl_1 = require("./components/dialogs/ctl/DlgSelectGameBetLinesDenomCtl");
var DlgCalculatePartnerRevshareCtl_1 = require("./components/dialogs/ctl/DlgCalculatePartnerRevshareCtl");
var DlgSetPProgramPartnerOfferCtl_1 = require("./components/dialogs/ctl/DlgSetPProgramPartnerOfferCtl");
var DlgSetPProgramPartnerTopCtl_1 = require("./components/dialogs/ctl/DlgSetPProgramPartnerTopCtl");
var DlgSetPromoCodeExpirationParamCtl_1 = require("./components/dialogs/ctl/DlgSetPromoCodeExpirationParamCtl");
var DlgSelectPlayerCtl_1 = require("./components/dialogs/ctl/DlgSelectPlayerCtl");
var DlgAddGameToAllCmsGameSetListsCtl_1 = require("./components/dialogs/ctl/DlgAddGameToAllCmsGameSetListsCtl");
var DlgBonusTemplateCustomZoneEditorCtl_1 = require("./components/dialogs/ctl/DlgBonusTemplateCustomZoneEditorCtl");
var DlgSmsRestrictionEditorCtl_1 = require("./components/dialogs/ctl/DlgSmsRestrictionEditorCtl");
var DlgWhiteIpEditorCtl_1 = require("./components/dialogs/ctl/DlgWhiteIpEditorCtl");
var DlgKeyValueEditorCtl_1 = require("../shared/dialogs/ctl/DlgKeyValueEditorCtl");
var DlgCloneBonusLocaleCtl_1 = require("./components/dialogs/ctl/DlgCloneBonusLocaleCtl");
var DIALOG = /** @class */ (function () {
    function DIALOG() {
    }
    Object.defineProperty(DIALOG, "DlgCloneBonusLocale", {
        get: function () {
            if (!this._DlgCloneBonusLocale) {
                this._DlgCloneBonusLocale = new DlgCloneBonusLocaleCtl_1.DlgCloneBonusLocaleCtl();
            }
            return this._DlgCloneBonusLocale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgKeyValueEditor", {
        get: function () {
            if (!this._DlgKeyValueEditor) {
                this._DlgKeyValueEditor = new DlgKeyValueEditorCtl_1.DlgKeyValueEditorCtl();
            }
            return this._DlgKeyValueEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgWhiteIpEditor", {
        get: function () {
            if (!this._DlgWhiteIpEditor) {
                this._DlgWhiteIpEditor = new DlgWhiteIpEditorCtl_1.DlgWhiteIpEditorCtl();
            }
            return this._DlgWhiteIpEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSmsRestrictionEditor", {
        get: function () {
            if (!this._DlgSmsRestrictionEditor) {
                this._DlgSmsRestrictionEditor = new DlgSmsRestrictionEditorCtl_1.DlgSmsRestrictionEditorCtl();
            }
            return this._DlgSmsRestrictionEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgBonusTemplateCustomZoneEditor", {
        get: function () {
            if (!this._DlgBonusTemplateCustomZoneEditor) {
                this._DlgBonusTemplateCustomZoneEditor = new DlgBonusTemplateCustomZoneEditorCtl_1.DlgBonusTemplateCustomZoneEditorCtl();
            }
            return this._DlgBonusTemplateCustomZoneEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgAddGameToAllCmsGameSetLists", {
        get: function () {
            if (!this._DlgAddGameToAllCmsGameSetLists) {
                this._DlgAddGameToAllCmsGameSetLists = new DlgAddGameToAllCmsGameSetListsCtl_1.DlgAddGameToAllCmsGameSetListsCtl();
            }
            return this._DlgAddGameToAllCmsGameSetLists;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSelectPlayer", {
        get: function () {
            if (!this._DlgSelectPlayer) {
                this._DlgSelectPlayer = new DlgSelectPlayerCtl_1.DlgSelectPlayerCtl();
            }
            return this._DlgSelectPlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSetPromoCodeExpirationParam", {
        get: function () {
            if (!this._DlgSetPromoCodeExpirationParam) {
                this._DlgSetPromoCodeExpirationParam = new DlgSetPromoCodeExpirationParamCtl_1.DlgSetPromoCodeExpirationParamCtl();
            }
            return this._DlgSetPromoCodeExpirationParam;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSetPProgramPartnerTop", {
        get: function () {
            if (!this._DlgSetPProgramPartnerTop) {
                this._DlgSetPProgramPartnerTop = new DlgSetPProgramPartnerTopCtl_1.DlgSetPProgramPartnerTopCtl();
            }
            return this._DlgSetPProgramPartnerTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSetPProgramPartnerOffer", {
        get: function () {
            if (!this._DlgSetPProgramPartnerOffer) {
                this._DlgSetPProgramPartnerOffer = new DlgSetPProgramPartnerOfferCtl_1.DlgSetPProgramPartnerOfferCtl();
            }
            return this._DlgSetPProgramPartnerOffer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgCalculatePartnerRevshare", {
        get: function () {
            if (!this._DlgCalculatePartnerRevshare) {
                this._DlgCalculatePartnerRevshare = new DlgCalculatePartnerRevshareCtl_1.DlgCalculatePartnerRevshareCtl();
            }
            return this._DlgCalculatePartnerRevshare;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgGameBetLineEditor", {
        get: function () {
            if (!this._DlgGameBetLineEditor) {
                this._DlgGameBetLineEditor = new DlgSelectGameBetLinesDenomCtl_1.DlgSelectGameBetLinesDenomCtl();
            }
            return this._DlgGameBetLineEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgNumericEditor", {
        get: function () {
            if (!this._DlgNumericEditor) {
                this._DlgNumericEditor = new DlgNumericEditorCtl_1.DlgNumericEditorCtl();
            }
            return this._DlgNumericEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSelectPProgramImage", {
        get: function () {
            if (!this._DlgSelectPProgramImage) {
                this._DlgSelectPProgramImage = new DlgSelectPProgramImage_1.DlgSelectPProgramImgCtl();
            }
            return this._DlgSelectPProgramImage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSelectBrandImage", {
        get: function () {
            if (!this._DlgSelectBrandImg) {
                this._DlgSelectBrandImg = new DlgSelectBrandImage_1.DlgSelectBrandImgCtl();
            }
            return this._DlgSelectBrandImg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgUploadProgress", {
        get: function () {
            if (!this._DlgUploadProgress) {
                this._DlgUploadProgress = new DlgUploadProgessCtl_1.DlgUploadProgressCtl();
            }
            return this._DlgUploadProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DialogApiError", {
        get: function () {
            if (!this._DialogApiError) {
                this._DialogApiError = new DlgApiErrorCtl_1.DlgApiErrorCtl();
            }
            return this._DialogApiError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSelectAvailAdmin", {
        get: function () {
            if (!this._DialogSelectAvailAdmin) {
                this._DialogSelectAvailAdmin = new DlgSelectAvailAdminCtl_1.DlgSelectAvailAdminCtl();
            }
            return this._DialogSelectAvailAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgDescriptionEditor", {
        get: function () {
            if (!this._DlgDescriptionEditor) {
                this._DlgDescriptionEditor = new DlgDescriptionEditCtl_1.DlgDescriptionEditCtl();
            }
            return this._DlgDescriptionEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgFinanceManualOperation", {
        get: function () {
            if (!this._DialogFinanceManualOperation) {
                this._DialogFinanceManualOperation = new DlgFinanceManualOperationCtl_1.DlgFinanceManualOperationCtl();
            }
            return this._DialogFinanceManualOperation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgGeneratePromoCodeOperation", {
        get: function () {
            if (!this._DlgGeneratePromoCodeOperation) {
                this._DlgGeneratePromoCodeOperation = new DlgGeneratePromoCodeOperationCtl_1.DlgGeneratePromoCodeOperationCtl();
            }
            return this._DlgGeneratePromoCodeOperation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgGenerateOnePromoCodeOperation", {
        //private static _DlgGenerateOnePromoCodeOperation : DlgGenerateOnePromoCodeOperationCtl;
        get: function () {
            if (!this._DlgGenerateOnePromoCodeOperation) {
                this._DlgGenerateOnePromoCodeOperation = new DlgGenerateOnePromoCodeOperationCtl_1.DlgGenerateOnePromoCodeOperationCtl();
            }
            return this._DlgGenerateOnePromoCodeOperation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgMessageEditor", {
        get: function () {
            if (!this._DlgMessageEditor) {
                this._DlgMessageEditor = new DlgMessageEditorCtl_1.DlgMessageEditorCtl();
            }
            return this._DlgMessageEditor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSendRawPlayerBroadcastMessage", {
        //private static _DlgSendRawParttnerMessage : DlgSendBroadcastRawPartnerMessageCtl;
        get: function () {
            if (!this._DlgSendRawUsrMessage) {
                this._DlgSendRawUsrMessage = new DlgSendBroadcastRawUserMessageCtl_1.DlgSendBroadcastRawUserMessageCtl();
            }
            return this._DlgSendRawUsrMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSendRawPartnerBroadcastMessage", {
        get: function () {
            if (!this._DlgSendRawPartnerMessage) {
                this._DlgSendRawPartnerMessage = new DlgSendBroadcastRawPartnerMessageCtl_1.DlgSendBroadcastRawPartnerMessageCtl();
            }
            return this._DlgSendRawPartnerMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgPlayersExport", {
        get: function () {
            if (!this._DlgPlayersExport) {
                this._DlgPlayersExport = new DlgExportList_1.DlgExportListCtl();
            }
            return this._DlgPlayersExport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgSelectKeyValueItem", {
        get: function () {
            if (!this._DlgSelectKeyValueItem) {
                this._DlgSelectKeyValueItem = new DlgSelectKeyValueItemCtl_1.DlgSelectKeyValueItemCtl();
            }
            return this._DlgSelectKeyValueItem;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgOpenFile", {
        get: function () {
            if (!this._DialogOpenFile) {
                this._DialogOpenFile = new DlgOpenFileCtl_1.DlgOpenFileCtl();
            }
            return this._DialogOpenFile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgYesNo", {
        get: function () {
            if (!this._DialogYesNo) {
                this._DialogYesNo = new DlgYesNoCtl_1.DlgYesNoCtl();
            }
            return this._DialogYesNo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgViewText", {
        get: function () {
            if (!this._DialogViewText) {
                this._DialogViewText = new DlgViewTextCtl_1.DlgViewTextCtl();
            }
            return this._DialogViewText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgLogout", {
        get: function () {
            if (!this._DialogLogout) {
                this._DialogLogout = new DlgLogoutCtl_1.DlgLogoutCtl();
            }
            return this._DialogLogout;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgPasswordChangeSelf", {
        get: function () {
            if (!this._DialogPasswordChangeSelf) {
                this._DialogPasswordChangeSelf = new DlgPwdChangeSelfCtl_1.DlgPwdChangeSelfCtl();
            }
            return this._DialogPasswordChangeSelf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgPasswordChangeAdm", {
        get: function () {
            if (!this._DialogPasswordChangeAdm) {
                this._DialogPasswordChangeAdm = new DlgPwdChangeAdmCtl_1.DlgPwdChangeAdmCtl();
            }
            return this._DialogPasswordChangeAdm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DIALOG, "DlgError", {
        get: function () {
            if (!this._DialogError) {
                this._DialogError = new DlgErrorCtl_1.DlgErrorCtl();
            }
            return this._DialogError;
        },
        enumerable: true,
        configurable: true
    });
    return DIALOG;
}());
exports.DIALOG = DIALOG;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/coreDialog.ts
// module id = 138
// module chunks = 0